import React from 'react';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import logo from '../assets/images/chosenlogo2.png'; // Ensure the correct path to the logo
import './Header.css'; // Import the CSS

const Header = () => {
  return (
    <header className="header">
      <div className="left">
        <img src={logo} alt="Logo" className="logo" />
        <div className="name"> <span className='hnsp'>Chosen IT Academy</span>
        <p className="tagline">Training Technologies for Chosen </p></div>
      </div>
      <div className="contact-info">
        <span className="phone">
          <FaPhoneAlt className="icon" /> Phone no: +91 9962690905
        </span>
        <span className="email">
          <FaEnvelope className="icon" /> Mail id: info@chosenacademy.co.in
        </span>
      </div>
    </header>
  );
};

export default Header;
